// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1VlRU","buttons":"SendReceipts_buttons__3qztP","email":"SendReceipts_email__12F8C","bookApptTitle":"SendReceipts_bookApptTitle__3pQtf"};